import { itemLetter } from "./toolBox";

export const computedCardOptions = ({
  cards,
  handleMatrix = true,
  handleCustom = false,
  handleOUserAttributes = false,
  handleLoop = false,
  hideChartsRecodes = true,
  currentValue = undefined,
}) => {
  const filteredCards = cards.filter((c) => (hideChartsRecodes ? !c.is_for_analytics : true));
  let options = filteredCards
    .map((card) => {
      if (card.type === "q_matrix" && handleMatrix) return computedItemOption(card);
      else if (card.type === "o_custom" && handleCustom) return computedCustomOption(card);
      else if (card.type === "o_user_attributes" && handleOUserAttributes) return computedUAOption(card);
      else if (card.type === "o_loop" && handleLoop) return computedLoopOption(card);
      else return computedOption(card);
    })
    .flat();

  if (currentValue && !options.find((o) => o.value === currentValue)) {
    options.push({ label: "N/A", value: currentValue, disabled: "true" });
  }

  return options;
};

const computedOption = (card) => {
  // option.value = "cardToken/[noItemToken]/[noUserAttribute]"
  return { label: `${card.name || "(untitled)"}`, value: `${card.token}//`, name: card.name };
};

const computedUAOption = (card) => {
  const specs = card.specs ?? {};
  // option.value = "cardToken/[noItemToken]/[noUserAttribute]"
  return { label: `UA. ${specs.attribute_name || "(untitled)"}`, value: `${card.token}//`, name: card.name };
};

const computedItemOption = (card) => {
  const specs = card.specs ?? {};
  // option.value = "cardToken/itemToken/[noUserAttribute]"
  return specs.items.map((item, itemIndex) => {
    const letter = itemLetter(itemIndex) || "";
    return {
      label: `${card.name}_ITEM_${letter}`,
      value: `${card.token}/${item.token}/`,
      name: `${card.name}_ITEM_${letter}`,
    };
  });
};
const computedCustomOption = (card) => {
  const specs = card.specs ?? {};
  // option.value = "cardToken/[noItemToken]/userAttribute"
  let values = [];
  if (["set_n_answers", "is_in_list", "answers_sample", "random_numbers"].includes(specs.method_name))
    values.push("NULL");
  if (["answers_sample", "random_numbers"].includes(specs.method_name)) {
    let limit = 0;
    switch (specs.method_name) {
      case "answers_sample":
        limit = Number(specs.max);
        break;
      case "random_numbers":
        limit = Number(specs.n);
        break;
    }
    for (let i = 1; i <= limit; i++) {
      values.push(i);
    }
  }

  return values.map((value) => {
    const valueLabel = value === "NULL" ? "" : value;
    return {
      label: `UA. ${specs.attribute_name}${valueLabel}`,
      value: `${card.token}//${value}`,
      name: card.name,
    };
  });
};

const computedLoopOption = (card) => {
  return { label: card.name, value: `${card.token}//`, name: card.name };
};

export const cardTokenToOption = (cardToken, defaultToNull = false) => {
  // option = "cardToken/itemToken/userAttribute"
  if (cardToken == undefined) return undefined;
  if (typeof cardToken === "string") return `${cardToken}//`;

  // If cardToken is an object
  // For some old custom card options, the user_attribute is a number instead of a string
  if (typeof cardToken.user_attribute === "number") cardToken.user_attribute = cardToken.user_attribute.toString();
  let UAValue = cardToken?.user_attribute ?? "";
  if (!cardToken?.item_token && !cardToken?.user_attribute && defaultToNull) UAValue = "NULL"; // for some custom card options
  return `${cardToken.card_token}/${cardToken?.item_token || ""}/${UAValue}`;
};

export const optionToCardToken = (cardTokenOption, cardTokenAsObj = false) => {
  if (cardTokenOption == undefined) return undefined;
  const [cardToken, itemToken = "", userAttribute = ""] = cardTokenOption.split("/");
  if (itemToken === "" && userAttribute === "" && cardTokenAsObj) return { card_token: cardToken || "" };
  if (itemToken === "" && userAttribute === "") return cardToken || "";
  if (itemToken.length > 0) return { card_token: cardToken, item_token: itemToken };
  if (userAttribute === "NULL") return { card_token: cardToken, user_attribute: null };
  return { card_token: cardToken, user_attribute: userAttribute };
};
